import * as React from "react";
import { Dropdown, IDropdownOption } from "@fluentui/react/lib/Dropdown";
import { ITriggerManualJob } from "../../../redux/types/ITriggerManualJob";
import { BOOK_EXPORT_JOB_TYPE, CWR_GENERATION_JOB_TYPE } from "../../Consts";
import { HIGH_WATER_MARK, INCLUDE_AGREEMENTS, JOB_CREATED_VIEW, LINK_TO_IPBASENUMBER, LOOKUP_WORKSOURCE, LOOKUP_WORKSTATUS, SCHEDULE, SEARCH_VIEW, SEARCH_VIEW_JOB_IP, SEPARATE_PUBLISHED, SHARE_SET, SOURCE_SOCIETY_STATE_KEY , SOCIETY_AFFILIATION_TERRITORY,INCLUDE_SOCIETY_AFFILIATION_FOR, INCLUDE_SOCIETY_AFFILIATION_OF } from "../../../repertoire/Consts";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import ActionButton, { InlineActionButton, SizedActionButton } from "../../../repertoire/components/actionButton/ActionButton";
import { showModal } from "../../../redux/reducers/ModalReducer";
import TextDataInput from "../../../repertoire/components/textDataInput/TextDataInput";
import {
    getPoolsThunk,
    triggerManualJob,
    upsertScheduledJobAsync,
} from "../../../redux/thunks/HomeThunks";
import DatePickerDataInput from "../../../repertoire/components/dateDataInput/DatePickerDataInput";
import { ICwrgParameters } from "../../../redux/types/ICwrgParameters";
import { SizedCheckboxDataInput } from "../../../repertoire/components/checkboxDataInput/CheckboxDataInput";
import { If } from "../../../core/components/If";
import { getLookupValues } from "../../../lookup/services/LookupHelpers";
import DropdownDataInput from "../../../repertoire/components/dropdownDataInput/DropdownDataInput";
import { SET_TYPE_LOOKUP, AGENCY_LOOKUP, TERRITORY_LOOKUP } from "../../../lookup/Consts";
import { MessageBanner, MessageType } from "../../../repertoire/components/messageBanner/MessageBanner";
import { IUsagePoolState } from "../../../redux/types/IUsagePoolState";

export interface ICWRGenerationJobParametersProps {
    lookupValues: ILookupDictionary,
    showModal: (
        modalContent: string,
        modalComponentInstance: string,
        modalProps: any,
        displayModalCloseButton: boolean,
        title: string
    ) => void,
    globalManualJobParams: any,
    upsertScheduledJobAsync: typeof upsertScheduledJobAsync,
    createNewJob: () => any,
    getCWRGHighWaterMark?: (cwrgParams: ICwrgParameters) => void,
    cwrgHighWaterMark?: any,
    setCWRGHighWaterMark?: (hwm: string) => void,
    triggerManualJob: typeof triggerManualJob,
    manualJobParameters: ITriggerManualJob,
    updateManualJobParams?: (params: any) => void,
    getSeparatePublishedCheckbox?: () => void,
    separatePublishedCheckbox?: boolean,
    getPools?: typeof getPoolsThunk,
    pools?: IUsagePoolState[],
    scheduledJobSet?: (value: boolean) => void,
    onError?: (errorMessage: string) => void
}


const CWRGenerationJobParameters = (props: ICWRGenerationJobParametersProps) => {

    const [sources, setSources] = React.useState<string[]>([]);
    const [statuses, setStatuses] = React.useState<string[]>([]);
    const [schedule, setScheduleState] = React.useState('')
    const [linkToIPBaseNumber, setLinkToIPBaseNumber] = React.useState(false)
    const [separatePublished, setSeparatePublished] = React.useState(false)
    const [includeAgreements, setIncludeAgreements] = React.useState(false)
    const [shareSet, setShareSet] = React.useState('');
    const [cronError, setCronError] = React.useState('');
    const [sourceSociety, setSourceSociety] = React.useState('');
    const [scheduleJobSet, setScheduleJobSet] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [societyAffiliationTerritories, setSocietyAffiliationTerritories] = React.useState<string[]>([]);
    const [societyAffiliationSocieties, setSocietyAffiliationSocieties] = React.useState<string[]>([]);
    const [societyAffiliationPools, setSocietyAffiliationPools] = React.useState<string[]>([]);

    const getGlobalParamValues = (): string => {
        const { globalManualJobParams } = props;

        let ipNameNumber = '';
        if (globalManualJobParams !== '') {
            const jobParams = JSON.parse(globalManualJobParams.jobParameters);
            ipNameNumber = jobParams.ipNameNumber;
        }
        return ipNameNumber
    }

    let ipNameNumber = getGlobalParamValues();

    React.useEffect(() => {
        const { getSeparatePublishedCheckbox } = props;
        getSeparatePublishedCheckbox();
    }, [])

    React.useEffect(() => {
        const { getPools, pools } = props;
        if (!pools?.length && getPools) {
            getPools();
        }
    }, [])

    React.useEffect(() => {
        getHighWaterMark();
    }, [ipNameNumber])

    React.useEffect(() => {
        getHighWaterMark();
    }, [sourceSociety])

    const showSearchModal = () => {
        const { showModal } = props;

        showModal(SEARCH_VIEW, SEARCH_VIEW_JOB_IP, {
            ipNameNumber: ipNameNumber,
        }, true, "Search");
    };

    const getHighWaterMark = () => {
        const { getCWRGHighWaterMark, cwrgHighWaterMark } = props;
        const highWaterMark = cwrgHighWaterMark;
        if (ipNameNumber === '') ipNameNumber = 'All';
        const cwrgParams: ICwrgParameters = {
            sources,
            statuses,
            ipNameNumber,
            highWaterMark,
            schedule,
            linkToIPBaseNumber,
            separatePublished,
            sourceSociety
        };
        getCWRGHighWaterMark(cwrgParams);
    }

    const getMultiSelectOptions = (lookupType: string) => {
        const { lookupValues } = props;

        var lookups = lookupValues[lookupType].lookups.filter((x) => x.code !== "NULL" && x.code !== null);

        const options = [];

        if (lookups) {
            lookups.map((c) => options.push({
                data: c.code,
                text: c.description,
                key: c.code
            }));
            options.sort((a, b) => a.text.localeCompare(b.text));
        }
        options.unshift({ key: "All", text: "All", data: "*" });
        return options;
    }

    const getTerritoryMultiSelectOptions = () => {
        const { lookupValues } = props;

        const lookups = lookupValues[TERRITORY_LOOKUP]?.lookups?.filter(
            (x) => x.code !== "NULL" && x.code !== null && !x.code.startsWith("2")
        ) ?? [];

        const options = lookups.map((c) => ({
            data: c.code,
            text: c.description,
            key: c.code
        }));
        options.sort((a, b) => a.text.localeCompare(b.text));
        options.unshift({ key: "All", text: "All", data: "*" });
        return options;
    }

    const getPoolMultiSelectOptions = () => {
        const { pools = [] } = props;

        const options = pools.map((pool) => ({
            data: pool.poolCode,
            text: pool.poolCode,
            key: pool.poolCode
        }));
        options.sort((a, b) => a.text.localeCompare(b.text));
        options.unshift({ key: "All", text: "All", data: "*" });
        return options;
    }

    const handleChangeMultiSelect = (lookupType: string, option?: IDropdownOption) => {

        let newOptions = [];
        if (lookupType === LOOKUP_WORKSOURCE) {
            newOptions = sources;
        } else if (lookupType === LOOKUP_WORKSTATUS) {
            newOptions = statuses;
        }

        let allOptions = getMultiSelectOptions(lookupType).map(x => x.key);
        allOptions = allOptions.filter(x => x !== "All");
        if (option.key == "All") {
            if (newOptions.length == allOptions.length) {
                newOptions = [];
            }
            else {
                newOptions = [];
                newOptions.push(...allOptions);
            }
        }
        else if (option.selected) {
            newOptions.push(option.key.toString());
        }
        else {
            newOptions.splice(newOptions.indexOf(option.key.toString()), 1);
        }

        if (lookupType === LOOKUP_WORKSOURCE) {
            setSources([...newOptions]);
        } else if (lookupType === LOOKUP_WORKSTATUS) {
            setStatuses([...newOptions]);
        }

        getHighWaterMark();
    };

    const handleChangeSocietyAffiliationMultiSelect = (
        field: "territories" | "societies" | "pools",
        option?: IDropdownOption
    ) => {
        let newOptions = [];
        let allOptions = [];

        if (field === "territories") {
            newOptions = societyAffiliationTerritories;
            allOptions = getTerritoryMultiSelectOptions().map(x => x.key);
        } else if (field === "societies") {
            newOptions = societyAffiliationSocieties;
            allOptions = getMultiSelectOptions(AGENCY_LOOKUP).map(x => x.key);
        } else {
            newOptions = societyAffiliationPools;
            allOptions = getPoolMultiSelectOptions().map(x => x.key);
        }

        allOptions = allOptions.filter(x => x !== "All");
        if (option.key == "All") {
            if (newOptions.length == allOptions.length) {
                newOptions = [];
            }
            else {
                newOptions = [];
                newOptions.push(...allOptions);
            }
        }
        else if (option.selected) {
            newOptions.push(option.key.toString());
        }
        else {
            newOptions.splice(newOptions.indexOf(option.key.toString()), 1);
        }

        if (field === "territories") {
            setSocietyAffiliationTerritories([...newOptions]);
        } else if (field === "societies") {
            setSocietyAffiliationSocieties([...newOptions]);
        } else {
            setSocietyAffiliationPools([...newOptions]);
        }
    };

    const isValidCron = (cron) => {
        const parts = cron.trim().split(/\s+/);
        if (parts.length !== 5 && parts.length !== 6) return false;

        const validators = [
            { name: 'second', regex: /^(\*|([0-5]?\d)(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ }, // optional
            { name: 'minute', regex: /^(\*|([0-5]?\d)(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'hour', regex: /^(\*|([01]?\d|2[0-3])(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'dayOfMonth', regex: /^(\*|([1-9]|[12]\d|3[01])(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'month', regex: /^(\*|(1[0-2]|0?[1-9])(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'dayOfWeek', regex: /^(\*|[0-6](\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ }
        ];

        const offset = parts.length === 5 ? 1 : 0;

        return parts.every((part, i) => validators[i + offset].regex.test(part));
    }


    const handleScheduleChange = (value: string | boolean | number, fieldname: string) => {
        setScheduleState(value.toString());
        setCronError('');
    }


    const handleHighWaterMarkChange = (value: string | boolean | Date, fieldname: string) => {
        const { setCWRGHighWaterMark } = props;
        setCWRGHighWaterMark(value?.toString() ?? '');
    }

    const dismissAlert = () => {
        setCronError('');
    };

    const setSchedule = () => {
        const { upsertScheduledJobAsync, createNewJob, cwrgHighWaterMark, scheduledJobSet } = props;

        const highWaterMark = cwrgHighWaterMark;
        const valid = isValidCron(schedule);
        if (ipNameNumber === '') ipNameNumber = 'All';

        let scheduledJob = {
            scheduledJobID: -1,
            cronSchedule: schedule,
            errorList: [],
            lastRunDate: null,
            parameters: JSON.stringify({
                sources,
                statuses,
                ipNameNumber,
                highWaterMark,
                linkToIPBaseNumber,
                separatePublished,
                includeAgreements,
                shareSet,
                sourceSociety,
                societyAffiliationTerritories,
                societyAffiliationSocieties,
                societyAffiliationPools
            }),
            type: CWR_GENERATION_JOB_TYPE
        }
        if (scheduledJob && valid) {
            setCronError('');
            scheduledJobSet(true);
            upsertScheduledJobAsync(scheduledJob);
            createNewJob();
        }
        else {
            setCronError('Please enter a valid Schedule expression.');
        }
    }

    const changeLinkToIPBaseNumber = (value, name) => {
        setLinkToIPBaseNumber(value);
    }

    const changeSeparatePublished = (value, name) => {
        setSeparatePublished(value);
    }

    const changeIncludeAgreements = (value, name) => {
        setIncludeAgreements(value);
    }

    const onChangeShareSet = (value, name) => {
        setShareSet(value);
    }
    
    const onChangeSourceSociety = (value, name) => {
        setSourceSociety(value);
    }

    const onClickSave = () => {
        const { triggerManualJob, createNewJob, updateManualJobParams, scheduledJobSet,onError } = props;
        const { cwrgHighWaterMark } = props;

        setLoading(true);
        try {

            if (ipNameNumber === '') ipNameNumber = 'All';
            const highWaterMark = cwrgHighWaterMark;

            const manualJobParameters: ITriggerManualJob = {
                jobType: CWR_GENERATION_JOB_TYPE,
                jobParameters: JSON.stringify({
                    sources,
                    statuses,
                    ipNameNumber,
                    highWaterMark,
                    linkToIPBaseNumber,
                    separatePublished,
                    includeAgreements,
                    shareSet,
                    sourceSociety,
                    societyAffiliationTerritories,
                    societyAffiliationSocieties,
                    societyAffiliationPools
                }),
            };
            scheduledJobSet(true);
            createNewJob();
            triggerManualJob(manualJobParameters);
            if (updateManualJobParams) {
                updateManualJobParams('');
            }

        }catch (error){
            onError?.(error?.toString() || "An error occurred");
        } finally {
            setLoading(false);
        }

    };

    const { cwrgHighWaterMark, lookupValues } = props;
    
    return (
        <>
            <div className="row">
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Source</label>
                    <Dropdown
                        selectedKeys={sources}
                        options={getMultiSelectOptions(LOOKUP_WORKSOURCE)}
                        multiSelect={true}
                        onChange={(e, o, i) => handleChangeMultiSelect(LOOKUP_WORKSOURCE, o)}
                        placeholder={""}
                        disabled={false} />
                </div>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Status</label>
                    <Dropdown
                        selectedKeys={statuses}
                        options={getMultiSelectOptions(LOOKUP_WORKSTATUS)}
                        multiSelect={true}
                        onChange={(e, o, i) => handleChangeMultiSelect(LOOKUP_WORKSTATUS, o)}
                        placeholder={""}
                        disabled={false} />
                </div>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>IP Name Number</label>
                    <div className="wrapperLookup">

                        <input
                            readOnly
                            type={"text"}
                            value={ipNameNumber}
                            maxLength={150}
                        />

                        <InlineActionButton buttonText="Lookup" className="buttonLookup"
                            buttonAction={() => showSearchModal()}
                        />
                    </div>
                </div>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Source Society</label>
                    <DropdownDataInput
                        fieldName={SOURCE_SOCIETY_STATE_KEY}
                        value={sourceSociety}
                        options={getLookupValues(AGENCY_LOOKUP, lookupValues)}
                        changeData={onChangeSourceSociety}
                        allowNull={true}
                        isHidden={false}
                    />
                </div>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <DatePickerDataInput
                        value={cwrgHighWaterMark}
                        fieldName={HIGH_WATER_MARK}
                        changeData={handleHighWaterMarkChange}
                        label={HIGH_WATER_MARK}
                        isHidden={false}
                        readOnly={false}
                    />
                </div>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <SizedCheckboxDataInput
                        label={LINK_TO_IPBASENUMBER}
                        fieldName={LINK_TO_IPBASENUMBER}
                        value={linkToIPBaseNumber}
                        changeData={changeLinkToIPBaseNumber}
                        readonly={false} />
                </div>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <SizedCheckboxDataInput
                        label={INCLUDE_AGREEMENTS}
                        fieldName={INCLUDE_AGREEMENTS}
                        value={includeAgreements}
                        changeData={changeIncludeAgreements}
                        readonly={false} />
                </div>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <DropdownDataInput
                        value={shareSet}
                        label={SHARE_SET}
                        changeData={onChangeShareSet}
                        fieldName={SHARE_SET}
                        options={getLookupValues(SET_TYPE_LOOKUP, lookupValues).filter(x => x.typeID < 0)}
                        allowNull={false}
                        isHidden={false}
                    ></DropdownDataInput>
                </div>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>{SOCIETY_AFFILIATION_TERRITORY}</label>
                    <Dropdown
                        selectedKeys={societyAffiliationTerritories}
                        options={getTerritoryMultiSelectOptions()}
                        multiSelect={true}
                        onChange={(e, o, i) => handleChangeSocietyAffiliationMultiSelect("territories", o)}
                        placeholder={""}
                        disabled={false} />
                </div>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>{INCLUDE_SOCIETY_AFFILIATION_OF}</label>
                    <Dropdown
                        selectedKeys={societyAffiliationSocieties}
                        options={getMultiSelectOptions(AGENCY_LOOKUP)}
                        multiSelect={true}
                        onChange={(e, o, i) => handleChangeSocietyAffiliationMultiSelect("societies", o)}
                        placeholder={""}
                        disabled={false} />
                </div>
                <div className="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>{INCLUDE_SOCIETY_AFFILIATION_FOR}</label>
                    <Dropdown
                        selectedKeys={societyAffiliationPools}
                        options={getPoolMultiSelectOptions()}
                        multiSelect={true}
                        onChange={(e, o, i) => handleChangeSocietyAffiliationMultiSelect("pools", o)}
                        placeholder={""}
                        disabled={false} />
                </div>
                <If condition={props.separatePublishedCheckbox}>
                    <div className="form-group col-md-6 col-sm-6 col-xs-12">
                        <SizedCheckboxDataInput
                            label={SEPARATE_PUBLISHED}
                            fieldName={SEPARATE_PUBLISHED}
                            value={separatePublished}
                            changeData={changeSeparatePublished}
                            readonly={false} />
                    </div>
                </If>
                <div className="form-group col-md-4 col-sm-6 col-xs-12">
                    <TextDataInput
                        label={SCHEDULE}
                        fieldName={SCHEDULE}
                        changeData={handleScheduleChange}
                        value={schedule}
                        isHidden={false}
                        isMandatory={false}
                    />
                </div>
                <div style={{ marginTop: 12 }} className="form-group col-md-2 col-sm-4 col-xs-12">
                    <ActionButton buttonText={"Set"} buttonAction={setSchedule} />
                </div>
            </div>
            {cronError && cronError !== '' && (
                <div className="alert alert-danger alert-dismissible">
                    <span>{cronError}</span>
                    <button type="button" className="close" aria-label="Close" onClick={dismissAlert}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>)}

            <div className="row">
                <div
                    className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                    <ActionButton buttonText={"Cancel"} buttonAction={props.createNewJob} className={"button btn-defaultSecondary"}/>
                </div>
                <div
                    className="form-group col-lg-4 col-lg-push-4 col-md-4 col-md-push-4 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0">
                    <ActionButton
                        buttonText={"Start Job"}
                        buttonAction={() => onClickSave()}
                        disabled={loading}
                    />
                </div>
            </div>
        </>
    );

}

export default CWRGenerationJobParameters;
